
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  .  .  .  . .  .  . .  .
    *    .       .       .       .       .       .       .       .       .       .       .       .
    *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
    *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
    *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
    *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
    *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
    *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
    *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
    *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
    *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
    *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
    *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
    *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
    *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
    *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *
 * Copyright FortyFix(c) 2024.
 * Title: Listino.ts;
 * Path: ./src/environments/Modules/Listino.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 20/02/25, 10:49;
 * Updated at: 20/02/25, 10:49;
 *
 */


export var Listino = () => {
    var env = {
        Modules: {
            "Listini":true,
        },
        Menu: [
            {
                module: "Listini",
                path: "listino/listini",
                title: 'menu.listini',
                icon: "fas fa-bars",
                capacita: ["menu-listino"],
            },
        ],
        ListinoAddOn: {
            aggiunte: false,
            imgProdotti: true,
            showFilteredImageList: true,
            showScadenza: true,
            notifiche: true,
            campiProdotto: [
                {
                    nome: 'Prezzo Scontato',
                    oggetti: ['prezzo'],
                    modificabile: true,
                    class: "col-lg-3",
                    inputType: 'number',
                    required: true
                },
                {
                    nome: 'Prezzo Pieno',
                    oggetti: ['prezzoNetto'],
                    modificabile: true,
                    class: "col-lg-3",
                    inputType: 'number',
                },
            ],
            campiListino: [
                {
                    nome: 'Fornitore',
                    oggetti: ['id_fornitore'],
                    source: '/anagrafica/clienti/list',
                    parameter: [{ nome: 'page', value: 0 }, { nome: 'size', value: 100 }, { nome: 'ruolo', value: 'F' }],
                    responseHasData: true,
                    modificabile: true,
                    class: "col-lg-3",
                    internalOutput: 'fornitoreObject',
                    inputType: 'singleDropdown',
                    OutputField: 'id_fornitore',
                    placeholder: 'Seleziona',
                    settings: {
                        singleSelection: true,
                        closeDropDownOnSelection: true,
                        singleOutput: true,
                        idField: 'id',
                        textField: 'nominativo',
                        allowSearchFilter: true,
                    },
                    required: true
                },
                {
                    nome: 'Data',
                    oggetti: ['data'],
                    modificabile: true,
                    class: "col-lg-3",
                    inputType: 'date',
                    required:true
                },
                {
                    nome: 'Data di scadenza',
                    oggetti: ['dataScadenza'],
                    modificabile: true,
                    class: "col-lg-3",
                    inputType: 'date',
                },
                {
                  prevDivClass: "col-md-12 mt-3",
                    nome: "Notificato",
                    oggetti: ["notificato"],
                    modificabile: true,
                    disabledif: {hasNotRoles: ["SA"]},
                    inputType: "checkbox",
                    class: "col-lg-3"
                  },
              {
                prevDivClass: "col-md-12 mt-3",
                nome: "Notificato Preferiti",
                oggetti: ["notificatoPreferiti"],
                modificabile: true,
                disabledif: {hasNotRoles: ["SA"]},
                inputType: "checkbox",
                class: "col-lg-3"
              },
              {
                nome: 'Data di Notifica',
                oggetti: ['dataNotifica'],
                modificabile: true,
                class: "col-lg-3",
                inputType: 'datetime-local',
              },
                {
                    prevDivClass: "col-md-12 mt-3",
                    modificabile: true,
                    nome: 'Allegato',
                    oggetti: [null],
                    inputType: 'file',
                    placeholder: '(pdf) Size Limit: 5.00 MB',
                    anteprima: "thumb",
                    visibleifProhibited: true
                },
            ]
        }
    };
    return env;
}
